import React, { useEffect, useState, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import socket from './service/socket'; // Socket Service
import MainLayout from './components/MainLayout';
import SidebarMenu from './components/SidebarMenu';
import BasicSidebarMenu from './components/BasicSidebarMenu';

import { openDrawerAction } from './redux/actions/OpenDrawerAction';

import PrivacyPolicy from './pages/PrivacyPolicy';
import DeleteMyAccount from './pages/DeleteMyAccount';
// Lazy-loaded components
const Home = React.lazy(() => import('./pages/Home'));
const HomeNew = React.lazy(() => import('./pages/HomeNew')); // Import HomeNew
const About = React.lazy(() => import('./pages/About'));
const NotFound = React.lazy(() => import('./pages/NotFound'));
const LoginHome = React.lazy(() => import('./pages/LoginHome'));
const Login = React.lazy(() => import('./pages/Login'));
const SignUp = React.lazy(() => import('./pages/Signup'));
const Profile = React.lazy(() => import('./pages/Profile'));
const Play = React.lazy(() => import('./pages/Play'));
const MyWins = React.lazy(() => import('./pages/MyWins'));
const BiddingDetails = React.lazy(() => import('./pages/BiddingDetails'));
const MyBiddings = React.lazy(() => import('./pages/MyBiddings'));
const Commission = React.lazy(() => import('./pages/Commission'));
const Chart = React.lazy(() => import('./pages/Chart.jsx'));
const NotificationsList = React.lazy(() => import('./pages/NotificationsList'));
const More = React.lazy(() => import('./pages/More'));
const TermsAndConditions = React.lazy(() =>
  import('./pages/TermsAndConditions'),
);
const GamesTopTab = React.lazy(() => import('./pages/GamesTopTab'));
const ResultHistory = React.lazy(() => import('./pages/ResultHistory'));
const ResultHistoryDetails = React.lazy(() =>
  import('./pages/ResultHistoryDetails'),
);
const AddCash = React.lazy(() => import('./pages/AddCash'));
const Withdraw = React.lazy(() => import('./pages/Withdraw'));
const Account = React.lazy(() => import('./pages/Account'));
const Statements = React.lazy(() => import('./pages/Statements'));
const ChatScreen = React.lazy(() => import('./pages/ChatScreen'));
const ForgotPassword = React.lazy(() => import('./pages/Forgot'));
const OtpVerify = React.lazy(() => import('./pages/OtpVerify'));
const HelpPage = React.lazy(() => import('./pages/HelpPage'));
const WinDetails = React.lazy(() => import('./pages/WinDetails'));
const Footer = React.lazy(() => import('./pages/Footer'));
const PlayStore = React.lazy(() => import('./pages/playstore'));
const BombayGamingCompany = React.lazy(() =>
  import('./pages/playstore/bgc.jsx'),
);
// const PlayStore = React.lazy(() => import('./pages/playstore/aaa.jsx'));

const ProductDetails = React.lazy(() => import('./pages/ProductDetails')); // Add ProductDetails
const FillDetails = React.lazy(() => import('./pages/FillDetails')); // Add FillDetails
const OrderHistory = React.lazy(() => import('./pages/OrderHistory'));
const OrderDetails = React.lazy(() => import('./pages/OrderDetails'));
const BasicProfile = React.lazy(() => import('./pages/BasicProfile'));

function App() {
  const dispatch = useDispatch();
  const token = useSelector((state) => state.userTokenReducer?.token);
  const userDetail = useSelector(
    (state) => state?.userDetailReducer?.userDetail,
  );
  const drawer = useSelector((state) => state.OpenDrawerReducer.drawer);
  const [newMessage, setNewMessage] = useState(null);

  // Socket Connection & Event Listeners
  useEffect(() => {
    if (token && userDetail?._id) {
      socket.emit('register', userDetail._id);
      const lastTimestamp = localStorage.getItem('lastTimestamp') || 0;
      socket.emit('fetchMissedMessages', {
        conversationId: userDetail._id,
        lastTimestamp,
      });

      const handleNewMessage = (message) => {
        socket.emit('ack', { status: 'received', messageId: message._id });
        localStorage.setItem('lastTimestamp', message.timestamp);
        setNewMessage(message);
      };

      const handleMessage = (data) => {
        console.log('📩 New Message:', data);
        toast.success(data.message);
        setNewMessage(data);
      };

      const handleNotification = (data) => {
        console.log('📩 New receiveNotification:', data);
        toast.success(data.message);
        setNewMessage(data);
      };

      const handleBalance = (data) => {
        console.log('💰 Balance Updated:', data);
      };

      socket.on('newMessage', handleNewMessage);
      socket.on('message', handleMessage);
      socket.on('receiveNotification', handleNotification);
      socket.on('balance', handleBalance);

      return () => {
        socket.off('newMessage', handleNewMessage);
        socket.off('message', handleMessage);
        socket.off('receiveNotification', handleNotification);
        socket.off('balance', handleBalance);
      };
    }
  }, [token, userDetail?._id]);

  return (
    <div className="flex flex-col items-center w-full max-w-600 mx-auto pb-20">
      {token && userDetail?.role === 'candidate' && (
        <SidebarMenu
          isOpen={drawer}
          closeSidebar={() => dispatch(openDrawerAction(false))}
        />
      )}

      {token && userDetail?.role === 'basic' && (
        <BasicSidebarMenu
          isOpen={drawer}
          closeSidebar={() => dispatch(openDrawerAction(false))}
        />
      )}

      <MainLayout title="Delhi Gemers">
        <Suspense fallback={<div>Loading...</div>}>
          <Routes>
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/delete-account" element={<DeleteMyAccount />} />
            <Route path="/" element={<Login />} />
            <Route path="/register" element={<SignUp />} />

            {!token && (
              <>
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/install" element={<PlayStore />} />
                <Route
                  path="/bombay-gaming-company"
                  element={<BombayGamingCompany />}
                />
                <Route path="/" element={<Login />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<SignUp />} />
                <Route path="/login-home" element={<LoginHome />} />
                <Route path="/about" element={<About />} />
              </>
            )}

            {token && userDetail?.role === 'basic' && (
              <>
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<SignUp />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/install" element={<PlayStore />} />
                <Route path="/bgc" element={<BombayGamingCompany />} />
                <Route path="/homes" element={<HomeNew />} />
                <Route path="/product-details" element={<ProductDetails />} />
                <Route path="/fill-details" element={<FillDetails />} />
                <Route path="/order-history" element={<OrderHistory />} />
                <Route path="/order-details" element={<OrderDetails />} />
                <Route path="/basic-profile" element={<BasicProfile />} />
                <Route path="/menu" element={<BasicSidebarMenu />} />
                <Route path="*" element={<NotFound />} />
              </>
            )}

            {token && userDetail?.role === 'candidate' && (
              <>
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/install" element={<PlayStore />} />
                <Route path="/chart" element={<Chart />} />
                <Route path="/home" element={<Home />} />
                <Route path="/biddings" element={<MyBiddings />} />
                <Route path="/bidding-detail" element={<BiddingDetails />} />
                <Route path="/mywins" element={<MyWins />} />
                <Route path="/commission" element={<Commission />} />
                <Route path="/notifications" element={<NotificationsList />} />
                <Route path="/play" element={<Play />} />
                <Route path="/more" element={<More />} />
                <Route path="/terms" element={<TermsAndConditions />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/play/game-tab" element={<GamesTopTab />} />
                <Route path="/result-history" element={<ResultHistory />} />
                <Route path="/add-cash" element={<AddCash />} />
                <Route path="/transaction-history" element={<Statements />} />
                <Route path="/withdraw" element={<Withdraw />} />
                <Route path="/account" element={<Account />} />
                <Route
                  path="/result-history-details"
                  element={<ResultHistoryDetails />}
                />
                {/* <Route path="/ChatScreen" element={<ChatScreen />} /> */}
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/otp-verify" element={<OtpVerify />} />
                <Route path="/help" element={<HelpPage />} />
                <Route
                  path="/winnings/:gameId/:game_name"
                  element={<WinDetails />}
                />
                <Route path="*" element={<NotFound />} />
              </>
            )}
          </Routes>
        </Suspense>
      </MainLayout>
      {token && (
        <Suspense fallback={<div>Loading Footer...</div>}>
          <Footer />
        </Suspense>
      )}
      <ToastContainer position="top-left" autoClose={500} />
    </div>
  );
}

export default App;
